import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "swiper/css";
import { SUCCESS_PARTNERS } from "../../constants/landingPage";

const SuccessPartnersCarousel = () => (
  <Swiper
    slidesPerView={4.5}
    spaceBetween={29}
    loop={true}
    autoplay={{ delay: 2000, disableOnInteraction: false }}
    modules={[Autoplay]}
    breakpoints={{
      768: {
        slidesPerView: 6,
        spaceBetween: 96,
      },
    }}
    className="success-partners__swiper"
  >
    {SUCCESS_PARTNERS.map((partner) => (
      <SwiperSlide key={partner.id}>
        <img
          src={partner.image}
          alt={partner.name}
          className="success-partners__logo"
        />
      </SwiperSlide>
    ))}
  </Swiper>
);

const SuccessPartners = () => (
  <div className="success-partners">
    <div className="success-partners__heading">
      <p className="success-partners__title">
        شركاء النجاح في{" "}
        <span className="success-partners__title-span">تدرب للأعمال</span>
      </p>
    </div>
    <SuccessPartnersCarousel />
  </div>
);

export default SuccessPartners;
